import React from 'react';

/**
 * Champ du formulaire de création : libellé (avec mention « requis »),
 * saisie avec unité éventuelle, indice dessous
 */
export const VcField = ({ label, required, hint, suffix, children, wide }) => (
  <label className={`vd-field ${wide ? 'vd-field--wide' : ''}`}>
    <span className="vd-field__label">
      {label}
      {required && <span className="vc-required">requis</span>}
    </span>
    <span className="vd-input-wrap">
      {children}
      {suffix && <span className="vd-input-wrap__suffix">{suffix}</span>}
    </span>
    {hint && <span className="vd-field__hint">{hint}</span>}
  </label>
);
